module.exports = __webpack_public_path__ + "img/power-01.a7eb3f36.svg";